export default __webpack_public_path__ + "static/media/kitchen3-afterK-768w.824eb92b.png";